import { post } from '../base';

export function getPosExportLink<T>(params: T) {
  return post('v3/commissions/posreport', { json: params }).json<string>();
}
